import { useState } from 'react';

import { CfFlowScreen } from './api/cloudflareFlowApi';
import {
  EMPTY_SCREEN_TRAIL,
  arriveAt,
  canStepBack,
  latestArrival,
  screenOnDisplay,
  stepBack,
  stepForward,
} from './cfScreenTrail';

export type CfScreenTrailNavigation = {
  screen: CfFlowScreen | undefined;
  canGoBack: boolean;
  goBack: () => void;
  goForward: () => void;
};

/**
 * Not derived from the flow's screen order: the server skips screens by
 * sub-case, so the current screen alone cannot say which one came before.
 */
export const useCfScreenTrail = (serverScreen: CfFlowScreen | undefined): CfScreenTrailNavigation => {
  const [trail, setTrail] = useState(EMPTY_SCREEN_TRAIL);

  if (serverScreen && serverScreen !== latestArrival(trail)) {
    setTrail(arriveAt(trail, serverScreen));
  }

  return {
    screen: screenOnDisplay(trail) ?? serverScreen,
    canGoBack: canStepBack(trail),
    goBack: () => setTrail(stepBack),
    goForward: () => setTrail(stepForward),
  };
};
